import {
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverHeader,
  PopoverArrow,
  PopoverBody,
  Box,
  HStack,
  Text,
  BoxProps,
  Stack,
  Portal,
  CloseButton,
} from '@chakra-ui/react'
import { MessageInformation } from 'src/components/icon'
import { colors } from 'src/lib/chakra-theme/foundations/colors'

type Props = {
  isVisible: boolean
  onClose: () => void
  placement?: 'top' | 'bottom'
  triggerHeight?: BoxProps['h']
}

export const MediaNotEnabledPopover: React.FC<Props> = ({
  isVisible,
  onClose,
  triggerHeight = '40px',
  placement = 'bottom',
}) => {
  return (
    <Popover placement={placement} isOpen={isVisible}>
      <PopoverTrigger>
        <Box h={triggerHeight} />
      </PopoverTrigger>
      <Portal>
        <PopoverContent
          bg="white"
          border="none"
          p="5"
          my="1"
          mx="2"
          borderRadius="lg"
          // md以上では成り行き幅にする
          w={{ base: '90svw', md: 'auto' }}
        >
          <CloseButton pos="absolute" top={1} right={1} onClick={onClose} />
          <PopoverHeader p="0" fontWeight="bold" border="0">
            <HStack spacing="6px">
              <MessageInformation size="24px" color={colors.blue[500]} />
              <Text>カメラ・マイクをONにしてください。</Text>
            </HStack>
          </PopoverHeader>
          <PopoverBody pl="30px" pr="0" pb="0" pt="3">
            <Stack>
              <Text>
                初回アクセス時には使用許可のダイアログが表示されます。
              </Text>
              <Text>
                <strong>「許可する」</strong>
                を押下してカメラ・マイクの使用を許可してください。
              </Text>
            </Stack>
          </PopoverBody>
          <PopoverArrow bg="white" shadowColor="white" />
        </PopoverContent>
      </Portal>
    </Popover>
  )
}
